import styled from 'styled-components';

import { BACKGROUND_COLOR_CHANGE_ON_HOVER } from './constants';
import IconPrepaidCard from './prepaid-card-icon';

export interface IMethodContainer {
  disableHover?: boolean;
  disableMethod?: boolean;
  hideBorder?: boolean;
}
export const MethodContainer = styled.div<IMethodContainer>`
  align-items: center;
  border: transparent;
  color: ${Styles.color.grey.three};
  display: flex;
  font-family: ${Styles.fontFamily.body};
  font-weight: normal;
  font-size: 0.875rem;
  height: 3.375rem;
  padding: 0 0.125rem;
  user-select: none;
  width: 100%;
  transition: opacity 2s ease-out, 0.15s;
  background-color: ${p => (p.disableMethod ? Styles.color.grey.four : 'none')};
  border-bottom: 1px solid ${p => (p.hideBorder ? 'transparent' : Styles.color.grey.four)};
  ${BACKGROUND_COLOR_CHANGE_ON_HOVER &&
  `&:hover {
    background-color: ${Styles.color.grey.five};
  }`}

  svg {
    min-width: 1.5rem;
    width: 1.5rem;
    height: auto;
  }
`;

export const MethodTypeWrapper = styled.div`
  align-items: center;
  padding: 0 8px 0 8px;
  display: flex;
  flex-grow: 2;
  height: inherit;
  text-align: left;
  color: ${Styles.color.grey.one};
  cursor: pointer;
  ${Styles.desktop`
    flex-grow: 3;
  `};

  span {
    margin-left: 8px;
    font-size: 13px;
    text-transform: capitalize;
  }

  svg {
    border-radius: 3px;
    min-width: 34px;
    width: 34px;
    height: auto;
  }
`;

export const MethodTypeDescription = styled.div`
  display: flex;
  align-items: center;
`;

export const MethodType = styled.span`
  display: inline-block;
  text-transform: capitalize;
`;

export const DefaultIndicatorContainer = styled.div`
  border: none;
  margin-right: 1.125rem;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const RemoveMethodWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const RemoveMethod = styled.button`
  background-color: transparent;
  border: 0;
  color: ${Styles.color.primary};
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: ${Styles.fontFamily.base};

  svg {
    fill: ${Styles.color.grey.three};
  }

  ${Styles.desktop`
    background-color: transparent;
  `}
`;

export const StyledIconPrepaidCard = styled(IconPrepaidCard)`
  fill: ${Styles.color.primary};
`;

export const PrepaidBalance = styled.span`
  display: flex;
  align-items: center;
`;

export const PrepaidMethodType = styled(MethodType)`
  display: flex;
  align-items: center;
`;

export const CreditCardAlias = styled.div`
  display: flex;
  align-items: center;
`;

export const EndsInWrapper = styled.div`
  margin: 0 8px 1px 0;
`;
